import React, { Fragment } from 'react'
import moment from 'moment'
import useTranslation from '../../../Hooks/UseTranslation'

type Props = {
    isNotRead: boolean,
    icon: any,
    data: any,
    onClick: any,
    timeDifference: string
}

const CncAnalisisNotification = (props: Props) => {

    const { t, language } = useTranslation()

    const project = props.data.project

    return (
        <div className={`${props.isNotRead ? 'dropdownnotification' : ''} dropdown-item d-flex`}
            onClick={props.onClick}
        >
            <div className="notification-icon" style={{ padding: '10px' }}>
                {props.icon}
            </div>
            <div className="notification-details flex-grow-1">
                <p className="m-0 d-flex align-items-center">
                    <span>{props.data.title}</span>
                    <span
                        className={`badge badge-pill badge-muted ml-1 mr-1`}
                    >
                        {props.data.status === 'read' ? null : (
                            <span className="badge badge-pill badge-primary ml-1 mr-1">
                                {t('NOTIFICATIONS_CNC_ANALYSIS:Pending')}
                            </span>
                        )}
                    </span>
                    <span className="flex-grow-1"></span>
                    <span className=" text-muted ml-auto">
                        {language === 'es' && (
                            <Fragment>
                                {t('NOTIFICATIONS_CNC_ANALYSIS:Ago')}{' '}
                                {props.timeDifference}
                            </Fragment>
                        )}
                        {language === 'en' && (
                            <Fragment>
                                {props.timeDifference}{' '}
                                {t('NOTIFICATIONS_CNC_ANALYSIS:Ago')}
                            </Fragment>
                        )}
                    </span>
                </p>
                <p className=" text-muted m-0">
                    <span className='notification-content'>
                        {t('NOTIFICATIONS_CNC_ANALYSIS:CNCHasNotBeenDoneYet')}{' '}
                        <strong>(CNC)</strong> {' '}
                        {t('NOTIFICATIONS_CNC_ANALYSIS:OfTheProject')}{' '}
                        <strong>{project.name}</strong>{' '}
                        {t('NOTIFICATIONS_CNC_ANALYSIS:OftheWeek')}{' '}
                        <strong>{props.data.projectWeek}</strong>{' '}
                        {t('NOTIFICATIONS_CNC_ANALYSIS:From')}{' '}
                        {moment().week(props.data.week).startOf('week').format('DD/MM/YYYY')}{' '}
                        {t('NOTIFICATIONS_CNC_ANALYSIS:To')}{' '}
                        {moment().week(props.data.week).endOf('week').format('DD/MM/YYYY')}.
                    </span>
                </p>
            </div>
        </div>
    )
}

export default CncAnalisisNotification